import moment from "moment";
import ProposalReviewer from "work/values/proposal-reviewer";
import EntityMember from "work/values/entity-member/entity-member"
import Guid from "common/values/guid/guid";

export default class ProposalReviewerAPIResponse {
  userId?: string;
  entityId?: string;
  canEdit?: boolean;
  dateApproved?: string;
  customMessage?: string;

  public deserialize(): ProposalReviewer {
    if (!this.userId) throw new Error('userId is required, but not returned from the API');
    if (!this.entityId) throw new Error('entityId is required, but not returned from the API');
    if (this.canEdit === undefined) throw new Error('canEdit is required, but not returned from the API');

    return new ProposalReviewer(
      new EntityMember(new Guid(this.entityId), new Guid(this.userId)),
      this.canEdit,
      this.dateApproved ? moment(this.dateApproved) : undefined,
      this.customMessage
    );
  }
}
